import { toast } from 'react-toastify';

export default function ToastSuccess({ content }) {
  const showToast = () => {
    toast.success(
      <div className="flex items-center gap-1">
        <img src="/svg/toast-success.svg" alt="success icon" />
        <span className="text-sm max-md:text-xs font-bold text-success">{content}</span>
      </div>,
      {
        className:
          '!bg-[#EEFFFA] !border-[1px] !border-success !rounded-lg !shadow-none !w-fit !max-w-[400px] max-md:!max-w-[300px]',
        bodyClassName: 'flex items-center !py-1.5',
      },
    );
  };

  return showToast();
}
